import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { websiteRequest } from 'src/editor/shared/utils/request'
import {
  GetWebsitePagesResponse,
  WebsitePageInterface,
} from 'src/editor/store/website-pages/website-pages-types'
import { WebsitePageResource } from 'src/shared/types/website-page-interface'

export const getWebsitePageById = (id: number) =>
  websiteRequest<WebsitePageInterface>(`website-pages/${id}`, 'GET')

export const getWebsitePages = async (
  websiteId: number,
): Promise<GetWebsitePagesResponse> => {
  return await websiteRequest<GetWebsitePagesResponse>(
    `websites/${websiteId}/pages`,
    'GET',
  )
}

export interface UpdateWebsitePageRequest {
  pageId: number
  name: string
  url: string
}

export const updateWebsitePageRequest = async ({
  pageId,
  name,
  url,
}: UpdateWebsitePageRequest) => {
  return await websiteRequest<UpdateWebsitePageRequest>(
    `website-pages/${pageId}`,
    'PUT',
    {
      data: {
        path: url,
        name,
      },
    },
  )
}

export interface CreateWebsitePageRequest {
  websiteId: number
  pageType: string
  name: string
  url: string
  locale: PageLocaleEnum
}

export const createWebsitePage = async ({
  websiteId,
  pageType,
  name,
  url,
  locale,
}: CreateWebsitePageRequest): Promise<WebsitePageResource> => {
  return await websiteRequest<WebsitePageResource>(
    `websites/${websiteId}/pages`,
    'POST',
    {
      data: {
        type: pageType,
        path: url,
        name,
        locale,
      },
    },
  )
}

export interface DeletePageRequest {
  pageId: number
}

export const deletePageRequest = async ({
  pageId,
}: DeletePageRequest): Promise<void> => {
  return await websiteRequest<void>(`website-pages/${pageId}`, 'DELETE')
}
